/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-01-21T19:19:46-08:00
* @Email:  daniel@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-20T13:11:17-07:00
*/



import React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { dimensions, spacing } from '../../style';

const style = StyleSheet.create({
  container: {
    padding: `0 ${spacing.PADDING_MD.padding}`,
    maxWidth: '1070px',
    margin: '0 auto'
  },

  relative: {
    position: 'relative'
  },

  fullWidth: {
    [dimensions.SCREEN_MAX_SM]: {
      padding: '0'
    }
  },

  //Padding values

  none: {
    padding: '0 0'
  },

  large: {
    padding: `0 ${spacing.PADDING_LG.padding}`,
  },

  thin: {
    maxWidth: '420px'
  },

  medium: {
    maxWidth: '640px'
  },

  marginEnds: {
    [dimensions.SCREEN_MIN_SM]: {
      ...spacing.MARGIN_TOP_LG,
      ...spacing.MARGIN_BOTTOM_LG
    }
  },

  spaceBottom: {
    [dimensions.SCREEN_MAX_SM]: {
      ...spacing.MARGIN_BOTTOM_LG
    }
  }
})

const Container = (props) => {

  const {
    relative,
    fullWidth,
    screenTop,
    width,
    padding,
    spacedBottom,
    styles
  } = props

  const classNames = [

    style.container,
    relative && style.relative,
    fullWidth && style.fullWidth,
    screenTop && style.marginEnds,
    width && style[width],
    padding && style[padding],
    spacedBottom && style.spaceBottom
  ]

  return (
    <div className={css(classNames, styles)}>
      {props.children}
    </div>
  )
}



export default Container;



// WEBPACK FOOTER //
// ./src/components/blocks/Container.jsx